/**
 * Average Card Widget - Muestra un promedio con etiqueta
 *
 * Widget para mostrar métricas de promedio de campos numéricos.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { WidgetWrapper } from './WidgetWrapper';

export interface AvgCardProps {
  title: string;
  value: number;
  field?: string;
  loading?: boolean;
  computing?: boolean;
  error?: string | null;
  onRefresh?: () => void;
  icon?: React.ReactNode;
  color?: string;
  decimals?: number;
}

export const AvgCard: React.FC<AvgCardProps> = ({
  title,
  value,
  field,
  loading = false,
  computing = false,
  error = null,
  onRefresh,
  icon,
  color = 'info.main',
  decimals = 2,
}) => {
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };

  return (
    <WidgetWrapper
      title={title}
      loading={loading}
      computing={computing}
      error={error}
      onRefresh={onRefresh}
      icon={icon}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 2,
        }}
      >
        <Typography
          variant="h2"
          component="span"
          sx={{
            fontWeight: 'bold',
            color,
            lineHeight: 1,
          }}
        >
          {formatNumber(value)}
        </Typography>
        {field && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {field}
          </Typography>
        )}
      </Box>
    </WidgetWrapper>
  );
};

export default AvgCard;
